import animatorBlockMeta from './block.json';
import { svgAnimatorIcon } from './icons';
import { getBlockLabelByName } from '@helpers/utils';
import edit from './edit';
import './style.scss';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = animatorBlockMeta;

registerBlockType(name, {
  ...settings,
  icon: svgAnimatorIcon,
  edit,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
